"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("mktDashboardIndexAddBtn", function () {
  return {
    restrict: "E",
    scope: {
      clickHandler: "<"
    },
    replace: true,
    controllerAs: "$ctrl",
    template: require("./mktDashboardIndexAddBtn.html"),
    controller: function controller($scope) {
      var ctrl = this;
      ctrl.onClick = function () {
        $scope.clickHandler && $scope.clickHandler();
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/dashboard/mktDashboardIndexAddBtn.js
// module id = 2841
// module chunks = 13